import { VApp } from 'vuetify/lib/components/VApp';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VApp,
    [
      _vm._t("default", null, null, {
        updatePage: _vm.updatePage,
        updating: _vm.updating,
        handleFiltersInit: _vm.handleFiltersInit,
        mapUrl: _vm.mapUrl,
        count: _vm.count,
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }